import { useState, useRef } from "react";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import MyAnimation from "./DotLottieReact";

const Forms = () => {
  const [validated, setValidated] = useState(false);
  const [formSent, setFormSent] = useState(false);
  const navigate = useNavigate();
  const formRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
    } else {
      // Send email using EmailJS
      emailjs
        .sendForm(
          "service_sezfwta",
          "template_rpha854",
          formRef.current,
          "aKUV5APZ2Uk6chmzf"
        )
        .then(() => {
          setFormSent(true);
          formRef.current.reset();
          setValidated(false);

          setTimeout(() => {
            navigate("/"); // Navigate to home after 2 seconds
          }, 2000);
        })

        .catch((error) => {
          console.error("Email send error:", error);
          alert("Failed to send email.");
        });
    }

    setValidated(true);
  };

  return (
    <>
      <section className="bg-body-tertiary">
        {/* <!-- contact details --> */}
        <div className=" contact-bg px-0 w-100 d-lg-flex justify-content-lg-around flex-lg-row  col-md-2   d-sm-flex flex-sm-column col-md-5 pt-lg-1 text-center fw-semibold pt-2 ">
          <div className="">
            <p className=" fw-semibold text-center  text-light">
              Community 9, Opposite Tema General Hospital
            </p>
          </div>
          <div>
            <p className="text-light">0550662915/0205925509</p>
          </div>
          <div className="">
            <p className="container text-light d-none d-sm-block">
              rapidlabdiagnostics@gmail.com/info@rapidlabdiagnotics.com
            </p>
          </div>
        </div>

        <nav className="  navbar navbar-expand-lg navbar-light px-lg-1 px-sm-2  ">
          <div className="pt-2 px-5" to="/">
            {" "}
            <img
              loading="lazy"
              width="199"
              height="189"
              src="images/assets/rapidLabLogo copy.png "
              alt="logo"
            />
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="  collapse navbar-collapse  d-lg-flex justify-content-end  "
            id="navbarNavAltMarkup"
          >
            <div className="  navbar-nav d-sm-flex align-items-center px-5 fs-6 fw-semibold gap-lg-5">
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/"
              >
                Home
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/about-us"
              >
                About Us
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/services"
              >
                Services
              </Link>
              <Link
                className="text-primary-emphasis btn-hover-underline"
                to="/packages"
              >
                Packages
              </Link>
            </div>
            {/* <!-- modal --> */}
          </div>
        </nav>
        {/* <!------------------------------ FORMS------------------------- --> */}
        <div className="d-lg-flex d-md-flex container">
          <div className="col-md-6 col-lg-6 col-sm-10 m-auto">
            <MyAnimation />
          </div>

          <div className="px-2 m-auto pt-0 col-lg-6 col-md-8 col-sm-12 h-100  glass-morph rounded-4 border border-2  border-secondary pb-2">
            <div className=" m-auto">
              {formSent ? (
                <div className="alert alert-success">
                  ✅ Thank you! Your message has been sent successfully.
                </div>
              ) : (
                <form
                  ref={formRef}
                  noValidate
                  className={`pt-sm-5  mb-4 mt-0 pt-0 mb-0 needs-validation ${
                    validated ? "was-validated" : ""
                  }`}
                  id="appointment-form"
                  onSubmit={handleSubmit}
                >
                  <div className="d-flex justify-content-center ">
                    <img
                      src="images/assets/rapidLablogo.png "
                      alt="rapidLogo"
                      style={{ width: "150px", height: "150px" }}
                    />
                  </div>
                  <h5 className="text-center text-primary-emphasis">
                    CONTACT US
                  </h5>

                  <h3 className="text-center text-primary-emphasis pb-2 pt-0 mt-0">
                    Make an Appointment
                  </h3>
                  <div className="form-group fw-semibold px-2">
                    <label
                      htmlFor="name"
                      className="form-label fs-6 text-primary-emphasis"
                    >
                      Full Name
                    </label>
                    <input
                      name="name"
                      type="text"
                      placeholder="Full Name"
                      className="form-control fs-6  text-primary-emphasis"
                      id="name"
                      required
                    />
                    <div className="invalid-feedback">
                      Please enter your full name.
                    </div>
                  </div>
                  <div className="form-group mb-3 fw-semibold px-2 pt-1">
                    <label
                      htmlFor="phone"
                      className="form-label fs-6  text-primary-emphasis"
                    >
                      Phone Number
                    </label>
                    <input
                      name="phone"
                      type="tel"
                      placeholder="e.g.,+233 055 123 4567"
                      className="form-control fs-6  text-primary-emphasis"
                      pattern="^\+?[0-9\s\-]{7,15}$"
                      id="phone"
                      required
                    />
                    <div className="invalid-feedback">
                      Please enter your phone number
                    </div>
                  </div>
                  <div className="form-group fw-semibold text-primary-emphasis px-2">
                    <label htmlFor="email" className="form-label fs-6">
                      Email
                    </label>
                    <input
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="form-control "
                      id="email"
                      required
                    />
                    <div className="invalid-feedback">
                      Please enter your email
                    </div>
                  </div>
                  <div className="form-group fw-semibold text-primary-emphasis px-2">
                    <label htmlFor="date" className="col-form-label fs-6">
                      Date
                    </label>
                    <input
                      name="date"
                      type="date"
                      placeholder="choose date"
                      className="form-control"
                      id="date"
                      required
                    />
                    <div className="invalid-feedback">Please choose a date</div>
                  </div>
                  <div className="form-group  fw-semibold text-primary-emphasis px-2">
                    <label htmlFor="message" className="col-form-label fs-6">
                      How may we help you ?
                    </label>
                    <textarea
                      name="message"
                      placeholder="Your message"
                      className="form-control"
                      id="message"
                      type="text"
                      required
                    />

                    <div className="invalid-feedback">
                      Please enter a message
                    </div>
                  </div>
                  <div className="modal-footer gap-2 pt-3  ">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg button-sub"
                      id="submitBtn"
                    >
                      Schedule an Appointment
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Forms;
